module.exports = __webpack_public_path__ + "static/cloud-man-1046bbf7ab27e4ab8344370adf8794b1.svg";